var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProperty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 272,
    viewBox: "0 0 250 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_1499_7187)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.999,
    y: 2,
    width: 90,
    height: 90,
    rx: 10,
    fill: "#9672FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.616 54.8971C123.106 54.8971 122.695 54.483 122.695 53.9751C122.695 53.4672 123.109 53.0531 123.616 53.0531H128.783C129.293 53.0531 129.704 53.4672 129.704 53.9751C129.704 54.483 129.29 54.8971 128.783 54.8971H123.616ZM115.764 53.9829C115.555 53.6704 115.639 53.2484 115.951 53.0374C116.263 52.8291 116.685 52.9124 116.896 53.225L117.265 53.7771L118.736 51.9852C118.975 51.6961 119.402 51.6544 119.694 51.8914C119.983 52.131 120.024 52.5582 119.787 52.8499L117.752 55.3269C117.708 55.3842 117.653 55.4363 117.591 55.4779C117.278 55.6863 116.857 55.603 116.646 55.2904L115.764 53.9829ZM115.764 47.4975C115.555 47.1849 115.639 46.763 115.951 46.552C116.263 46.3436 116.685 46.427 116.896 46.7395L117.265 47.2917L118.736 45.4998C118.975 45.2106 119.402 45.169 119.694 45.406C119.983 45.6456 120.024 46.0728 119.787 46.3645L117.752 48.8414C117.708 48.8987 117.653 48.9508 117.591 48.9925C117.278 49.2009 116.857 49.1175 116.646 48.805L115.764 47.4975ZM115.764 41.0094C115.555 40.6969 115.639 40.2749 115.951 40.064C116.263 39.8556 116.685 39.939 116.896 40.2515L117.265 40.8037L118.736 39.0117C118.975 38.7226 119.402 38.6809 119.694 38.918C119.983 39.1576 120.024 39.5847 119.787 39.8764L117.752 42.3534C117.708 42.4107 117.653 42.4628 117.591 42.5045C117.278 42.7128 116.857 42.6295 116.646 42.3169L115.764 41.0094ZM123.616 41.1657C123.106 41.1657 122.695 40.7516 122.695 40.2437C122.695 39.7358 123.109 39.3217 123.616 39.3217H133.062C133.572 39.3217 133.983 39.7358 133.983 40.2437C133.983 40.7516 133.569 41.1657 133.062 41.1657H123.616ZM111.857 31H138.15C138.741 31 139.277 31.2396 139.662 31.6251C140.048 32.0106 140.287 32.5471 140.287 33.1384V60.8616C140.287 61.4529 140.048 61.9894 139.662 62.3749C139.277 62.7604 138.741 63 138.15 63H111.857C111.266 63 110.73 62.7604 110.345 62.3749C109.957 61.9946 109.717 61.4555 109.717 60.8642V33.141C109.717 32.5497 109.957 32.0106 110.342 31.6251C110.727 31.2396 111.266 31 111.857 31ZM138.15 32.8441H111.857C111.773 32.8441 111.698 32.8779 111.643 32.9326C111.589 32.9873 111.555 33.0628 111.555 33.1462V60.8694C111.555 60.9528 111.589 61.0283 111.643 61.083C111.698 61.1377 111.773 61.1716 111.857 61.1716H138.15C138.233 61.1716 138.309 61.1377 138.364 61.083C138.418 61.0283 138.452 60.9528 138.452 60.8694V33.1462C138.452 33.0628 138.418 32.9873 138.364 32.9326C138.306 32.8779 138.231 32.8441 138.15 32.8441ZM123.616 48.0314C123.106 48.0314 122.695 47.6173 122.695 47.1094C122.695 46.6015 123.109 46.1874 123.616 46.1874H133.062C133.572 46.1874 133.983 46.6015 133.983 47.1094C133.983 47.6173 133.569 48.0314 133.062 48.0314H123.616Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_1499_7187",
    x: -0.000976562,
    y: 0.703704,
    width: 250,
    height: 271.296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.85185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57407
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.588235 0 0 0 0 0.447059 0 0 0 0 1 0 0 0 0.0168519 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1499_7187"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.14815
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25926
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.588235 0 0 0 0 0.447059 0 0 0 0 1 0 0 0 0.0274815 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1499_7187",
    result: "effect2_dropShadow_1499_7187"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.588235 0 0 0 0 0.447059 0 0 0 0 1 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1499_7187",
    result: "effect3_dropShadow_1499_7187"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 38.5185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.7407
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.588235 0 0 0 0 0.447059 0 0 0 0 1 0 0 0 0.0425185 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1499_7187",
    result: "effect4_dropShadow_1499_7187"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 64.8148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.4259
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.588235 0 0 0 0 0.447059 0 0 0 0 1 0 0 0 0.0531481 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1499_7187",
    result: "effect5_dropShadow_1499_7187"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.588235 0 0 0 0 0.447059 0 0 0 0 1 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_1499_7187",
    result: "effect6_dropShadow_1499_7187"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_1499_7187",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.be11d5ad55d3e2e173dfce851c40f859.svg";
export { ForwardRef as ReactComponent };